export const createQuiz = (payload?: any) => ({
    type: "@saga/CREATE_QUIZ",
    payload
});

